import {
  AuthRequestPasswordResetPayload,
  AuthResetPasswordPayload,
  AuthResponse,
  AuthValidateResetTokenPayload,
  ChangePasswordPayload,
  LoginPayload,
  LoginPayloadNew,
  SignUpPayload,
  SignUpResponse, VerifyResponse,
} from './types'
import { useApi } from '@/composables/use-api'

export const AuthApi = {
  async exchangeTokenRequest(access_token: string) {
    const result = await useApi().post<AuthResponse>('../users/marketplace/sign-in/', {
      access_token,
    })

    return result.data
  },

  async loginUserRequest(data: LoginPayload) {
    const result = await useApi().post<AuthResponse>('../users/sign-in/', data)

    return result.data
  },

  async loginUserRequestNew(data: LoginPayloadNew) {
    const result = await useApi().post<AuthResponse>('../users/sign-in/request-code/', data)

    return result.data
  },

  async refreshTokensRequest(refreshToken: string) {
    const result = await useApi().post<AuthResponse>('/auth/refresh', {
      body: { refreshToken },
    })

    return result.data
  },

  async verifyCode(email: string, code: string) {
    const result = await useApi().post<VerifyResponse>('../auth/token/obtain-by-email-code/',
      { email, code }
    )

    return result.data
  },

  async requestPasswordResetRequest(email: string) {
    const result = await useApi().post<AuthRequestPasswordResetPayload>(
      '/auth/request-password-reset',
      {
        body: { email },
      },
    )

    return result.data
  },

  async validateResetTokenRequest(token: string, uniqueId: string) {
    const result = await useApi().post<AuthValidateResetTokenPayload>(
      '/auth/validate-reset-token',
      {
        method: 'POST',
        body: { token, uniqueId },
      },
    )

    return result.data
  },

  async changePasswordRequest(payload: ChangePasswordPayload) {
    const result = await useApi().post<AuthResetPasswordPayload>('/auth/change-password', {
      body: payload,
    })

    return result.data
  },

  async resetPasswordRequest(
    token: string,
    uniqueId: string,
    password: string,
    password_confirm: string,
  ) {
    const result = await useApi().post<AuthResetPasswordPayload>('/auth/reset-password', {
      body: { token, uniqueId, password, password_confirm },
    })

    return result.data
  },

  async signUpRequest(payload: SignUpPayload): Promise<SignUpResponse> {
    const result = await useApi().post<SignUpResponse>('../users/sign-up/', payload)

    return result.data
  },

  async signUpRequestNew(payload: SignUpPayload): Promise<SignUpResponse> {
    const result = await useApi().post<SignUpResponse>('../users/sign-up/', payload)

    return result.data
  },
}
